import {
    SublocalityFiltersExperiment,
    SublocalityFiltersExperimentValues,
    useServerEnrolledStatsigExperiment,
} from '@eventbrite/discover-utils';
import { useMemo } from 'react';
import { getParentLocationForSlug } from './sublocalities';

export const useIsInSublocalityExperiment = (locationSlug?: string) => {
    const parentLocation = useMemo(
        () => getParentLocationForSlug(locationSlug),
        [locationSlug],
    );

    const SublocalityFiltersExperimentVariant =
        useServerEnrolledStatsigExperiment<SublocalityFiltersExperimentValues>({
            name: SublocalityFiltersExperiment.name,
            paramName: SublocalityFiltersExperiment.paramName,
            defaultValue: SublocalityFiltersExperiment.values.control,
            enabled: !!parentLocation,
        }).variant;

    return {
        isSublocalityFilterExperiment:
            SublocalityFiltersExperimentVariant === 'test' && !!parentLocation,
        parentLocation,
    };
};
